import { trackEvent } from '@fiverr-private/gtm';

const VERTICAL_PAGE_LOAD_EVENT = 'vertical_page_perseus_page_load';

export const trackVerticalPageLoad = (data: DataLayerObjectType) => trackEvent(VERTICAL_PAGE_LOAD_EVENT, data);
